import {
  FormControl as MuiFormControl,
  FormControlProps,
  Theme,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const getCommonFormControlStyles = (
  theme: Theme,
  disabled: FormControlProps["disabled"],
) => {
  const { palette, typography } = theme;
  return {
    color: palette.secondary[3],
    fontSize: typography.small.fontSize,
    background: "transparent",
    opacity: disabled ? 0.5 : 1,
  };
};

const getFormControlStyles = (
  theme: Theme,
  variant: FormControlProps["variant"],
  disabled: FormControlProps["disabled"],
) => ({
  ...getCommonFormControlStyles(theme, disabled),
  ...(variant === "filled" && {
    "& .MuiFormLabel-root.MuiInputLabel-root.Mui-focused": {
      color: theme.palette.secondary[2],
    },
    "& .MuiInputBase-root.MuiFilledInput-root.Mui-focused": {
      background: theme.palette.secondary["8"],
      border: `1px solid ${theme.palette.secondary[5]}`,
    },
    "& .MuiInputBase-root.MuiFilledInput-root.Mui-disabled": {
      background: theme.palette.secondary["8"],
      border: `1px solid ${theme.palette.secondary[6]}`,
    },
  }),
});

export const StyledFormControl = styled(MuiFormControl)<FormControlProps>(
  ({ theme, variant, disabled }) =>
    getFormControlStyles(theme, variant, disabled),
);
